import Vue from 'vue'
import App from './App.vue'
import router from './router'

import { store } from './store'

import BootstrapVue from 'bootstrap-vue'
Vue.use(BootstrapVue)

import VueResource from 'vue-resource'
Vue.use(VueResource);

import Scrollspy from 'vue2-scrollspy';
Vue.use(Scrollspy);

import VueSimpleAlert from "vue-simple-alert";
Vue.use(VueSimpleAlert);

import VueCountdown from '@chenfengyuan/vue-countdown';
Vue.component(VueCountdown.name, VueCountdown);


import VideoBg from 'vue-videobg'
Vue.component('video-bg', VideoBg)


import videojsseekbuttons from 'videojs-seek-buttons';
Vue.component('videojsseekbuttons', videojsseekbuttons)

import Vue2TouchEvents from 'vue2-touch-events' 
Vue.use(Vue2TouchEvents)

import vClickOutside from 'v-click-outside'
Vue.use(vClickOutside)


Vue.config.productionTip = false


import '@fortawesome/fontawesome-free/css/all.css'
import '@fortawesome/fontawesome-free/js/all.js'

import 'bootstrap/dist/css/bootstrap.css'
import './app.scss'

Vue.mixin({
  methods: {

    isNull: function (str)
    {
      return (str == '' || str == null || str == undefined);
    },

    api_call: function(settings){

        if (this.isNull(settings.onComplete))
        {
          settings.onComplete = function(){};
        }
        else
        {
          var real_func = settings.onComplete;
          settings.onComplete = function(data){
            real_func(data);
          };
        }
        
        if (this.isNull(settings.data)) settings.data = {};
        settings.data.api_user_token = 'YWtOMVYyMWhUalIxZVV0b1lYUlRUbXR6WkRsWlNFWXZaWFJUZFRGdVltOVBhVnBUVm1Sdk5VTlJNRDA9';
        
        //return this.$http.post(window.api_url + settings.url + '?&ts=' + (new Date()).getHours() + '_' + ((new Date()).getMinutes() < 30 ? '0' : '30') , settings.data).then(settings.onComplete);
          return this.$http.post(window.api_url + settings.url , settings.data).then(settings.onComplete);

    },

    is_mobile: function(){ 

      return ( navigator.userAgent.match(/Android/i)
   || navigator.userAgent.match(/webOS/i)
   || navigator.userAgent.match(/iPhone/i)
  // || navigator.userAgent.match(/iPad/i)
   || navigator.userAgent.match(/iPod/i)
   || navigator.userAgent.match(/BlackBerry/i)
   );
  },
  add_to_fav(id){
      
    var self = this;
    
    var settings = { 
      item_id: id, 
      api_user_token: localStorage.getItem('user_token')
    };

    this.$http.post(window.api_url + 'user/add_favorite', settings)
    .then(function(/*data*/){
      
      self.$alert('הסרט נוסף לרשימת הצפייה שלך');
      
    });
    

  }

   }
  })
  

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
